(function() {
    try {
        if (!window.location.pathname.match(/\/cart\/?$/)) return;

        let isProcessing = true, isAddingGift = false, checkoutButtons = [];

        const failedGiftIds = (() => {
            try { return new Set(JSON.parse(sessionStorage.getItem('salepify_failed_ids')) || []); } catch(e) { return new Set(); }
        })();
        const saveFailed = () => sessionStorage.setItem('salepify_failed_ids', JSON.stringify([...failedGiftIds]));

        const originalFetch = window.fetch;
        window.fetch = async function(...args) {
            const res = await originalFetch.apply(this, args);
            if (typeof args[0] === 'string' && args[0].includes('cart/add.js') && res.status === 422) {
                try {
                    const body = JSON.parse(args[1]?.body || '{}');
                    body.items?.forEach(item => item.id && failedGiftIds.add(String(item.id)));
                    saveFailed();
                } catch (e) {}
            }
            return res;
        };

        const isCheckoutElement = (el) => {
            if (!el) return false;
            const href = el.getAttribute('href'), name = el.getAttribute('name'), id = el.getAttribute('id');
            return (el.tagName === 'A' && href && /\/checkouts?/i.test(href)) ||
                   ['checkout', 'goto_checkout'].includes(name) || id === 'checkout' ||
                   (el.classList && (el.classList.contains('checkout') || el.classList.contains('cart-checkout')));
        };

        // --- GỘP LOCK / UNLOCK NÚT CHECKOUT ---
        const toggleButtons = (lock) => {
            if (lock) {
                document.querySelectorAll('a, button, input[type="submit"], input[type="button"]').forEach((btn) => {
                    if (isCheckoutElement(btn) && !btn.hasAttribute('data-sl-lock')) {
                        btn.setAttribute('data-sl-lock', 'true');
                        btn.setAttribute('data-sl-txt', btn.tagName === 'INPUT' ? btn.value : btn.innerText || btn.textContent);
                        btn.style.pointerEvents = 'none'; btn.style.opacity = '0.65'; btn.setAttribute('disabled', 'disabled');
                        checkoutButtons.push(btn);
                    }
                });
            } else {
                checkoutButtons.forEach((btn) => {
                    const txt = btn.getAttribute('data-sl-txt');
                    if (txt) { btn.tagName === 'INPUT' ? btn.value = txt : (btn.childElementCount === 0 && (btn.innerText = txt)); }
                    ['data-sl-lock', 'data-sl-txt'].forEach(a => btn.removeAttribute(a));
                    btn.style.pointerEvents = btn.style.opacity = ''; btn.removeAttribute('disabled');
                });
                checkoutButtons = [];
            }
        };

        setTimeout(() => { if (isProcessing) { isProcessing = false; toggleButtons(false); } }, 4000);

        document.addEventListener('submit', (e) => {
            if (isProcessing && e.target?.getAttribute('action') === '/cart') {
                e.preventDefault(); e.stopPropagation();
            }
        }, true);

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            try {
                toggleButtons(isProcessing);

                if (window.tlCartGoalEmbed && !window.tlCartGoalEmbed._isCustomOverridden) {
                    window.tlCartGoalEmbed._isCustomOverridden = true;

                    // 1. Override handleAutoAddMultipleGift
                    const originalAutoAdd = window.tlCartGoalEmbed.handleAutoAddMultipleGift;
                    window.tlCartGoalEmbed.handleAutoAddMultipleGift = async function() {
                        try {
                            isProcessing = isAddingGift = true; toggleButtons(true);
                            const result = await originalAutoAdd.apply(this, arguments);
                            
                            let anyFailed = false;
                            try {
                                const list = arguments[0];
                                if (Array.isArray(list) && this.milestones) {
                                    list.forEach(idx => JSON.parse(this.milestones[idx]?.gifts || '[]').forEach(g => {
                                        if (failedGiftIds.has(String(g.id.split("/")[4]))) anyFailed = true;
                                    }));
                                }
                            } catch (errCheck) {}

                            if (anyFailed) {
                                isProcessing = isAddingGift = false; toggleButtons(false);
                                return result;
                            }

                            if (window.location.pathname.match(/\/cart\/?$/)) window.location.reload();
                            return result;
                        } catch (e) {
                            isProcessing = isAddingGift = false; toggleButtons(false);
                            throw e;
                        }
                    };

                    // 2. Override getPassedMilestone
                    const originalGetPassedMilestone = window.tlCartGoalEmbed.getPassedMilestone;
                    window.tlCartGoalEmbed.getPassedMilestone = function() {
                        try {
                            isProcessing = true; toggleButtons(true);
                            const promise = originalGetPassedMilestone.apply(this, arguments);
                            
                            promise.finally(() => {
                                try {
                                    if (window.location.pathname.match(/\/cart\/?$/)) {
                                        const passedGift = this.passedMilestone ? this.passedMilestone.gift : -1;
                                        const added = this.milestoneIndexMapGift ? this.milestoneIndexMapGift.get(passedGift) : undefined;
                                        const noGift = !added || (Array.isArray(added) && added.length === 0);
                                        
                                        let isGiftFailed = false;
                                        if (passedGift !== -1 && this.milestones) {
                                            try {
                                                isGiftFailed = JSON.parse(this.milestones[passedGift]?.gifts || '[]').every(g => failedGiftIds.has(String(g.id.split("/")[4])));
                                            } catch (errJson) {}
                                        }
                                        
                                        if (passedGift !== -1 && noGift && !isGiftFailed) {
                                            if (!isAddingGift) {
                                                isAddingGift = true;
                                                this.handleAutoAddMultipleGift([passedGift]);
                                            }
                                            return;
                                        } else if (isGiftFailed) {
                                            isProcessing = false; toggleButtons(false);
                                        }

                                        if (this.cartItems) {
                                            const cartContainer = document.querySelector('cart-items') || document.querySelector('form[action="/cart"]') || document.body;
                                            if (cartContainer) {
                                                let hasUnrenderedGift = false;
                                                this.cartItems.forEach((item) => {
                                                    if (item.properties && item.properties[this.PROPERTY || "_salepify-progress-bar"]) {
                                                        const isRendered = cartContainer.innerHTML.includes(String(item.variant_id || item.id)) || (item.handle && cartContainer.innerHTML.includes(item.handle));
                                                        if (!isRendered) hasUnrenderedGift = true;
                                                    }
                                                });
                                                
                                                if (hasUnrenderedGift) {
                                                    const lastReload = sessionStorage.getItem('salepify_last_reload');
                                                    const now = Date.now();
                                                    if (!lastReload || (now - parseInt(lastReload, 10) > 5000)) {
                                                        sessionStorage.setItem('salepify_last_reload', String(now));
                                                        window.location.reload(); return;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    isProcessing = false; toggleButtons(false);
                                } catch (innerError) {
                                    isProcessing = false; toggleButtons(false);
                                }
                            });
                            return promise;
                        } catch (e) {
                            isProcessing = false; toggleButtons(false);
                            return originalGetPassedMilestone.apply(this, arguments);
                        }
                    };

                    // Trigger ngay khi load
                    const embed = window.tlCartGoalEmbed;
                    const passedGift = embed.passedMilestone ? embed.passedMilestone.gift : -1;
                    if (passedGift !== -1) {
                        const added = embed.milestoneIndexMapGift ? embed.milestoneIndexMapGift.get(passedGift) : undefined;
                        const noGift = !added || (Array.isArray(added) && added.length === 0);
                        let failed = false;
                        try { failed = JSON.parse(embed.milestones?.[passedGift]?.gifts || '[]').every(g => failedGiftIds.has(String(g.id.split("/")[4]))); } catch (e) {}
                        
                        if (noGift && !isAddingGift && !failed) {
                            isAddingGift = true; embed.handleAutoAddMultipleGift([passedGift]);
                        }
                    }
                }

                if (!isProcessing || Date.now() - startTime > 15000) clearInterval(checkInterval);
            } catch (e) { isProcessing = false; toggleButtons(false); }
        }, 50);
    } catch (globalError) {}
})();
